import aiGradientSvg from 'assets/svg/ai_gradient.svg';
import classNames from 'classnames';
import { FC, ReactNode } from 'react';

type BorderGradientProps = {
  children: ReactNode;
  containerClassName?: string;
  className?: string;
};

const BorderGradient: FC<BorderGradientProps> = ({
  className,
  containerClassName,
  children,
}) => {
  return (
    <div
      className={classNames(
        'flex-1 bg-cover bg-no-repeat bg-center rounded-[12px] p-[6px]',
        containerClassName,
      )}
      style={{ backgroundImage: `url(${aiGradientSvg})` }}
    >
      <div className={classNames('h-full rounded-[6px] bg-white', className)}>
        {children}
      </div>
    </div>
  );
};

export default BorderGradient;
